import {
  MERCHANT_DATA_FAILD,
  MERCHANT_DATA_SUCCESS,
  MERCHANT_DATA_LOADING,
  MERCHANT_DATA_REMOVE,
} from "../types";
import api from "../../api";
import { getMerchantEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";

export const getMerchantById = (id: any, token: any, type?: string) => {
  return async (
    dispatch: (arg0: {
      type: string;
      loading?: boolean;
      payload?: any;
      merchantId?: any;
      error?: any;
    }) => void
  ) => {
    dispatch({ type: MERCHANT_DATA_LOADING, loading: true });
    try {
      const res = await api.get(
        getMerchantEndpoint(id, type),
        type === "checkout"
          ? {}
          : {
              headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
      );
      dispatch({ type: MERCHANT_DATA_LOADING, loading: false });
      dispatch({
        type: MERCHANT_DATA_SUCCESS,
        payload: res.data,
        merchantId: id,
      });
    } catch (err: any) {
      apiError(MERCHANT_DATA_LOADING, MERCHANT_DATA_FAILD, err, dispatch);
    }
  };
};

export const RemoveMerchantData = () => {
  return {
    type: MERCHANT_DATA_REMOVE,
  };
};
